const state = () => ({
    entry: []
})

const mutations = {
    setVideos(state, { video }) {
        state.entry[0] = video
    },
    clearAll(state) {
        state.entry = []
    }
}

const actions = {
    async setVideos({ commit }, { video }) {
        commit('setVideos', { video })
    },
    async clearAll({ commit }) {
        commit('clearAll')
    }
}

const getters = {
    entry: state => state.entry
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};